import {
    Button,
    Card,
    Col,
    DatePicker,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Tooltip
} from "antd";
import React, {useEffect, useState} from "react";
import adminService from "../../../../service/adminService";
import {
    MSG_CURRENT_YIELD_DETAIL_SAVE_FAILURE,
    MSG_CURRENT_YIELD_DETAIL_SAVED_SUCCESS,
    MSG_CURRENT_YIELD_DETAIL_UPDATE_FAILURE,
    MSG_CURRENT_YIELD_DETAIL_UPDATED_SUCCESS,
    MSG_FAILED_TO_FETCH_FUND_DETAILS_LIST_ERROR,
    MSG_FAILED_TO_FETCH_FUND_LIST_ERROR,
    MSG_FUND_DETAIL_UPDATE_FAILURE,
    MSG_FUND_DETAIL_UPDATED_SUCCESS,
    MSG_NO_CHANGES_TO_UPDATE
} from "../../../../util/Messages";
import ErrorHandler from "../../../../util/ErrorHandler";
import '../../styles.scss';
import {EditOutlined, ExclamationCircleOutlined, EyeOutlined,} from "@ant-design/icons";
import TableSearchComp from "../../../../components/common/tableSearch/TableSearchComp";
import CommonFunction from "../../../../util/CommonFunction";
import {FundDetailDto} from "../../../../dto/admin/FundDetailDto";
import {
    COMMON_DROPDOWN,
    DIGITS_AND_DOT_VALIDATION,
    NOT_AVAILABLE,
    ONLY_NUMERIC_VALIDATION,
    PARAMETER_LIST,
    YYYY_MM_DD
} from "../../../../util/Constants";
import {capitalize, toNumber} from "lodash";
import Validation from "../../../../util/Validation";
import modal from "antd/es/modal";
import dayjs from "dayjs";
import {InputDropdownParameterDto} from "../../../../dto/InputDropdownParameterDto";
import customerService from "../../../../service/customerService";
import {DropdownListDto} from "../../../../dto/DropdownListDto";
import {CurrentYieldDetailDto} from "../../../../dto/admin/CurrentYieldDetailDto";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSackDollar} from "@fortawesome/free-solid-svg-icons";


const FundDetails = () => {
    const [form] = Form.useForm();
    const [currentYieldForm] = Form.useForm();
    const [fundList, setFundList] = useState<FundDetailDto[]>([]);
    const [selectedFundDetail, setSelectedFundDetail] = useState<FundDetailDto>();
    const [currentYieldDetailDto, setCurrentYieldDetailDto] = useState<CurrentYieldDetailDto>();
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isCurrentYieldRequired, setCurrentYieldRequired] = useState(false);
    const [isDateRequired, setDateRequired] = useState(false);
    const [isCurrentYieldModalOpen, setCurrentYieldModalOpen] = useState(false);
    const [fundDropdownList, setFundDropdownList] = useState<DropdownListDto[]>([]);


    const columns = [
        {
            title: 'No',
            dataIndex: 'key',
            render: (text: any, rec: any, index: number) => {
                return (<span>{index + 1}</span>)
            }
        },
        {
            title: 'Fund Name',
            dataIndex: 'fundName',
            key: 'fundName',
            sorter: (a: any, b: any) => {
                a = a.fundName == null ? '' : a.fundName
                b = b.fundName == null ? '' : b.fundName
                return a.localeCompare(b);
            },
            ...TableSearchComp('fundName', 'Fund Name'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Symbol',
            dataIndex: 'symbol',
            key: 'symbol',
            sorter: (a: any, b: any) => {
                a = a.symbol == null ? '' : a.symbol
                b = b.symbol == null ? '' : b.symbol
                return a.localeCompare(b);
            },
            ...TableSearchComp('symbol', 'Symbol'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),

        },
        {
            title: 'ISIN',
            dataIndex: 'isin',
            key: 'isin',
            align: 'center',
            sorter: (a: any, b: any) => {
                a = a.isin == null ? '' : a.isin
                b = b.isin == null ? '' : b.isin
                return a.localeCompare(b);
            },
            ...TableSearchComp('isin', 'ISIN'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Fund Code',
            dataIndex: 'fundCode',
            key: 'fundCode',
            sorter: (a: any, b: any) => {
                a = a.fundCode == null ? '' : a.fundCode
                b = b.fundCode == null ? '' : b.fundCode
                return a.localeCompare(b);
            },
            ...TableSearchComp('fundCode', 'Fund Code'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Management Fee',
            dataIndex: 'managementFee',
            key: 'managementFee',
            sorter: (a: any, b: any) => (a.managementFee - b.managementFee),
            ...TableSearchComp('managementFee', 'Management Fee'),
            render: (text: any) => (
                null != text ? text.toFixed(3) : NOT_AVAILABLE
            ),
        },
        {
            title: 'Bank',
            dataIndex: 'bank',
            key: 'bank',
            sorter: (a: any, b: any) => {
                a = a.bank == null ? '' : a.bank
                b = b.bank == null ? '' : b.bank
                return a.localeCompare(b);
            },
            ...TableSearchComp('bank', 'Bank'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Account No',
            dataIndex: 'accountNo',
            key: 'accountNo',
            sorter: (a: any, b: any) => {
                a = a.accountNo == null ? '' : a.accountNo
                b = b.accountNo == null ? '' : b.accountNo
                return a.localeCompare(b);
            },
            ...TableSearchComp('accountNo', 'Account No'),
            render: (text: any) => (
                CommonFunction.validateText(text)
            ),
        },
        {
            title: 'Current Yield',
            dataIndex: 'yield',
            key: 'yield',
            sorter: (a: any, b: any) => (a.yield - b.yield),
            ...TableSearchComp('yield', 'Current Yield'),
            render: (text: any) => (
                null != text ? text.toFixed(2) : NOT_AVAILABLE
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: "center",
            sorter: (a: any, b: any) => {
                a = a.status == null ? '' : a.status
                b = b.status == null ? '' : b.status
                return a.localeCompare(b);
            },
            filters: [
                {
                    text: 'Active',
                    value: PARAMETER_LIST.ACTIVE,
                },
                {
                    text: 'Inactive',
                    value: PARAMETER_LIST.INACTIVE,
                }
            ],
            onFilter: (value: string, record: any) => record.status.indexOf(value) === 0,
            render: (text: string) => (
                <>
                    {
                        text === PARAMETER_LIST.ACTIVE ?
                            <Tag color="success">
                                Active
                            </Tag>
                            :
                            <Tag color="red">
                                Inactive
                            </Tag>
                    }


                </>
            ),
        },

        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (text: any, rec: FundDetailDto) => (
                <Space size="middle">
                    <Tooltip placement="top" title='View'>
                        <Button className='btn-action-outline-common btn-action-view'
                                icon={<EyeOutlined/>} onClick={() => onView(rec)}>View</Button>
                    </Tooltip>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        fetchAllFundDetails();
    }, [])

    const onView = (record: FundDetailDto) => {
        setSelectedFundDetail(record)
        form.setFieldsValue({
            status: record.status,
            accountNo: record.accountNo,
            bank: record.bank,
            managementFee: toNumber(record.managementFee).toFixed(3),
            fundCode: CommonFunction.validateText(record.fundCode),
            isin: CommonFunction.validateText(record.isin),
            symbol: CommonFunction.validateText(record.symbol),
            fundName: CommonFunction.validateText(record.fundName),
            yield: null != record.yield ? toNumber(record.yield).toFixed(2) : null,
            yieldDate: null != record.yieldDate ? dayjs(record.yieldDate) : null
        })

        setModalOpen(true)
    }

    const loadFundList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.FUND_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setFundDropdownList(res.data.results.activeItemList)
                fetchCurrentYieldDetails()
            } else {
                message.error(MSG_FAILED_TO_FETCH_FUND_LIST_ERROR).then();
                setIsLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setIsLoading(false)

        })
    }
    const fetchAllFundDetails = () => {
        setIsLoading(true)
        adminService.getAllFundDetails().then(res => {
            if (res.data !== null) {
                setFundList(res.data.results)
                setIsLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_FUND_DETAILS_LIST_ERROR).then();
                setIsLoading(false)

            }
        }, (reason) => {
            setIsLoading(false)
            ErrorHandler.handleError(reason);
        })
    }

    const fetchCurrentYieldDetails = () => {
        adminService.getCurrentYieldDetails().then(res => {
            if (res.data.results !== undefined) {
                let results = res.data.results as CurrentYieldDetailDto;
                setCurrentYieldDetailDto(results)
                currentYieldForm.resetFields()
                currentYieldForm.setFieldsValue({
                    yield: results.yield.toFixed(2),
                    yieldDate: dayjs(results.date),
                    fundId: results.fundId
                })
                setCurrentYieldModalOpen(true)
                setIsLoading(false)
            } else {
                currentYieldForm.resetFields()
                setCurrentYieldModalOpen(true)
                setIsLoading(false)

            }
        }, (reason) => {
            setIsLoading(false)
            ErrorHandler.handleError(reason);
        })
    }

    const replaceNotAvailableTag = (values: FundDetailDto): FundDetailDto => {
        return {
            ...values,
            fundName: NOT_AVAILABLE === values.fundName ? null : values.fundName,
            symbol: NOT_AVAILABLE === values.symbol ? null : values.symbol,
            isin: NOT_AVAILABLE === values.isin ? null : values.isin,
            fundCode: NOT_AVAILABLE === values.fundCode ? null : values.fundCode,
        } as FundDetailDto
    }
    const updateFundDetail = () => {
        form.validateFields().then(() => {
            let values = form.getFieldsValue();

            values = replaceNotAvailableTag(values);
            if (checkFieldUpdates(selectedFundDetail as FundDetailDto, values)) {
                values.id = selectedFundDetail?.id
                modal.confirm({
                    title: 'Confirm',
                    className: 'confirm-dialog-box',
                    icon: <ExclamationCircleOutlined/>,
                    content: `Are you sure?, Do you want to update this detail?`,
                    okText: 'Yes',
                    cancelText: 'No',
                    okButtonProps: {style: {background: '#FF7400'}},
                    onOk() {
                        handleCancel()
                        setIsLoading(true)
                        adminService.updateFundDetail(values).then((res) => {
                            if (res.data.results) {
                                message.success(MSG_FUND_DETAIL_UPDATED_SUCCESS)
                                fetchAllFundDetails()
                            } else {
                                message.error(MSG_FUND_DETAIL_UPDATE_FAILURE)
                                setIsLoading(false)
                            }
                        }, (reason) => {
                            ErrorHandler.handleError(reason);
                            setIsLoading(false)

                        })
                    },
                    onCancel() {
                        setIsLoading(false)
                    }
                });
            } else {

                message.warning(MSG_NO_CHANGES_TO_UPDATE)
            }
        }).catch(() => {

        })
    }

    const updateCurrentYieldDetail = () => {

        currentYieldForm.validateFields().then(() => {
            let values = currentYieldForm.getFieldsValue();

            let isCanSave: boolean = undefined == currentYieldDetailDto;

            if (checkCurrentYieldFieldUpdates(currentYieldDetailDto as CurrentYieldDetailDto, values)) {
                modal.confirm({
                    title: 'Confirm',
                    className: 'confirm-dialog-box',
                    icon: <ExclamationCircleOutlined/>,
                    content: `Are you sure?, Do you want to ${isCanSave ? 'save' : 'update'} this current yield detail?`,
                    okText: 'Yes',
                    cancelText: 'No',
                    okButtonProps: {style: {background: '#FF7400'}},
                    onOk() {
                        handleCurrentYieldModalCancel()
                        setIsLoading(true)

                        let currentYieldDto = {
                            id: currentYieldDetailDto?.id,
                            fundId: values.fundId,
                            yield: values.yield,
                            date: dayjs(values.yieldDate).format(YYYY_MM_DD)
                        } as CurrentYieldDetailDto;

                        adminService.saveOrUpdateCurrentYieldDetail(currentYieldDto).then((res) => {
                            if (res.data.results) {
                                message.success(isCanSave ? MSG_CURRENT_YIELD_DETAIL_SAVED_SUCCESS : MSG_CURRENT_YIELD_DETAIL_UPDATED_SUCCESS)
                                fetchAllFundDetails()
                            } else {
                                message.error(isCanSave ? MSG_CURRENT_YIELD_DETAIL_SAVE_FAILURE : MSG_CURRENT_YIELD_DETAIL_UPDATE_FAILURE)
                                setIsLoading(false)
                            }
                        }, (reason) => {
                            ErrorHandler.handleError(reason);
                            setIsLoading(false)

                        })
                    },
                    onCancel() {
                        setIsLoading(false)
                    }
                });
            } else {
                message.warning(MSG_NO_CHANGES_TO_UPDATE)

            }
        }).catch(() => {

        })
    }

    const checkFieldUpdates = (oldValues: FundDetailDto, newValues: FundDetailDto) => {
        let yieldDate = null != newValues.yieldDate ? dayjs(newValues.yieldDate).format(YYYY_MM_DD) : null;
        let date = null != oldValues.yieldDate ? dayjs(oldValues.yieldDate).format(YYYY_MM_DD) : null;
        const managementFee = null != newValues.managementFee ? toNumber(newValues.managementFee).toFixed(3) : null;
        const currentYield = null != newValues.yield ? toNumber(newValues.yield).toFixed(2) : null;

        if (oldValues.managementFee != managementFee) {
            return true;
        } else if (oldValues.bank != newValues.bank) {
            return true;
        } else if (oldValues.accountNo != newValues.accountNo) {
            return true;
        } else if (oldValues.status != newValues.status) {
            return true;
        } else if (date != yieldDate) {
            return true;
        } else if (oldValues.yield != currentYield) {
            return true;
        }
        return false;
    }
    const checkCurrentYieldFieldUpdates = (oldValues: CurrentYieldDetailDto, newValues: any) => {
        if (undefined === oldValues) {
            return true;
        }

        let yieldDate = dayjs(newValues.yieldDate).format(YYYY_MM_DD);
        let date = dayjs(oldValues.date).format(YYYY_MM_DD);

        if (date != yieldDate) {
            return true;
        } else if (oldValues.yield != newValues.yield) {
            return true;
        } else if (oldValues.fundId != newValues.fundId) {
            return true;
        }
        return false;
    }
    const handleCancel = () => {
        setModalOpen(false)
    }

    const handleCurrentYieldModalCancel = () => {
        setCurrentYieldDetailDto(undefined)
        setCurrentYieldModalOpen(false)
    }
    const handleYieldBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (DIGITS_AND_DOT_VALIDATION.test(value)) {
            form.setFieldsValue({yield: toNumber(value).toFixed(2)})
            form.validateFields(["yield"]);
        }

    };
    const handleManagementFeeBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (DIGITS_AND_DOT_VALIDATION.test(value)) {
            form.setFieldsValue({managementFee: toNumber(value).toFixed(3)})
            form.validateFields(["managementFee"]);
        }

    };

    const onMangeCurrentYield = () => {
        setIsLoading(true)
        loadFundList()
    }

    const validatePercentage = (_: any, value: any) => {
        if (value && (toNumber(value) < 0 || toNumber(value) > 100)) {
            return Promise.reject(new Error('Percentage must be between 0 and 100'));
        }
        return Promise.resolve();
    };

    const onDateChange = (value: any) => {
        if (null != value) {
            setCurrentYieldRequired(true)
        } else {
            setCurrentYieldRequired(false)
            setDateRequired(false)
            form.resetFields(['yield'])
        }
    }
    const onYieldChange = (value: any) => {
        if ("" == value.target.value || null == value.target.value) {
            setDateRequired(false)
            setCurrentYieldRequired(false)
            form.resetFields(['yieldDate'])
        } else {
            setDateRequired(true)
        }
    }

    return (
        <>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <FontAwesomeIcon icon={faSackDollar}/>
                        </div>
                         Fund Details
                    </h2>
                    {/*<div style={{position: 'absolute', bottom: 16, right: 8}}>*/}
                    {/*    <Button type="primary" style={{height: 36}} onClick={onMangeCurrentYield}>*/}
                    {/*        Manage Current Yield*/}
                    {/*    </Button>*/}
                    {/*</div>*/}
                </Col>
            </Row>
            <Row gutter={[16, 16]} className='margin_top_30'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Table scroll={{x: 'max-content'}} columns={columns} dataSource={fundList} loading={isLoading}/>
                </Col>
            </Row>
            <Modal title="Update Fund Detail"
                   className={'modal-body-scroll-only disabled-data-show-inputs-container'}
                   open={isModalOpen}
                   footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered
                   style={{top: 20, paddingBottom: 20}}
                   destroyOnClose={true}
                   maskClosable={false}>
                <Row gutter={[24, 12]} className={'form-item-mb-12 modal-body-scroll-only-main-row'}
                     style={{marginTop: 18}}>
                    <Col span={24}>
                        <Card title="Fund Detail" size={'small'}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Fund Name"
                                            name={"fundName"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Symbol"
                                            name={"symbol"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="ISIN"
                                            name={"isin"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Fund Code"
                                            name={"fundCode"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Bank Name"
                                            name={"bank"}
                                            onKeyPress={Validation.onlyAlphabeticWithSpace}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please enter bank name'
                                                }
                                            ]}>
                                            <Input placeholder={"Enter bank name"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Account Number"
                                            name={"accountNo"}
                                            onKeyPress={Validation.isNumberWithoutDot}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please enter account number'
                                                },
                                                {
                                                    max: 30,
                                                    message: 'The maximum length is 30 numbers'
                                                },
                                                {
                                                    pattern: ONLY_NUMERIC_VALIDATION,
                                                    message: 'These special characters are not allowed'
                                                }
                                            ]}>
                                            <Input placeholder={"Enter account number"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={12} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label={'Management Fee'}
                                            name={'managementFee'}
                                            rules={[
                                                {
                                                    validator: validatePercentage
                                                },
                                                {
                                                    required: true,
                                                    message: 'Please enter management fee'
                                                },
                                                {
                                                    pattern: DIGITS_AND_DOT_VALIDATION,
                                                    message: 'These special characters are not allowed'
                                                }]}>
                                            <Input onKeyPress={Validation.isNumber}
                                                   onBlur={handleManagementFeeBlur}
                                                   autoComplete="off"
                                                   addonAfter="%"
                                                   placeholder={"Enter fee"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={12} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Status"
                                            name={"status"}>
                                            <Select placeholder={"Select status"}
                                                    getPopupContainer={(trigger: {
                                                        parentNode: any;
                                                    }) => trigger.parentNode}
                                                    style={{width: '100%'}}
                                                    options={
                                                        [
                                                            {
                                                                value: PARAMETER_LIST.ACTIVE,
                                                                label: capitalize(PARAMETER_LIST.ACTIVE)
                                                            },
                                                            {
                                                                value: PARAMETER_LIST.INACTIVE,
                                                                label: capitalize(PARAMETER_LIST.INACTIVE)
                                                            }
                                                        ]
                                                    }
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={12} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Date"
                                            name={"yieldDate"}
                                            rules={[{
                                                required: isDateRequired,
                                                message: 'Please select date'
                                            }]}>
                                            <DatePicker
                                                showToday={false}
                                                disabledDate={(d) => {
                                                    const today = dayjs();
                                                    return !d || (d.isBefore(today.subtract(5, 'day')) && d.isBefore(today));
                                                }}
                                                placeholder={'Select date'}
                                                style={{width: '100%'}}
                                                onChange={onDateChange}
                                            />

                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={12} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label={'Current Yield'}
                                            name={'yield'}
                                            rules={[
                                                {
                                                    validator: validatePercentage
                                                },
                                                {
                                                    required: isCurrentYieldRequired,
                                                    message: 'Please enter percentage'
                                                },
                                                {
                                                    pattern: DIGITS_AND_DOT_VALIDATION,
                                                    message: 'These special characters are not allowed'
                                                }
                                            ]}>
                                            <Input onKeyPress={Validation.isNumber}
                                                   onBlur={handleYieldBlur}
                                                   autoComplete="off"
                                                   addonAfter="%"
                                                   onChange={onYieldChange}
                                                   placeholder={"Enter yield"}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            <Button icon={<EditOutlined/>} type="success" onClick={updateFundDetail}
                                    style={{
                                        width: 100,
                                        background: "#008d86",
                                        color: "white",
                                    }}>Update</Button>
                        </Space>
                    </Col>
                </Row>

            </Modal>

            {/*<Modal title="Add / Update Current Yield"*/}
            {/*       className={'modal-body-scroll-only'}*/}
            {/*       open={isCurrentYieldModalOpen}*/}
            {/*       footer={null}*/}
            {/*       onCancel={handleCurrentYieldModalCancel}*/}
            {/*       width={800}*/}
            {/*       centered*/}
            {/*       style={{top: 20, paddingBottom: 20}}*/}
            {/*       destroyOnClose={true}*/}
            {/*       maskClosable={false}>*/}
            {/*    <Row gutter={[24, 12]} className={'form-item-mb-12 modal-body-scroll-only-main-row'}*/}
            {/*         style={{marginTop: 18}}>*/}
            {/*        <Col span={24}>*/}
            {/*            <Card title="Current Yield Detail" size={'small'}>*/}
            {/*                <Form*/}
            {/*                    className='form-input'*/}
            {/*                    layout={"vertical"}*/}
            {/*                    form={currentYieldForm}*/}
            {/*                >*/}
            {/*                    <Row gutter={[12, 0]}>*/}
            {/*                        <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>*/}
            {/*                            <Form.Item*/}
            {/*                                label="Fund Name"*/}
            {/*                                name={"fundId"}*/}
            {/*                                rules={[{*/}
            {/*                                    required: true,*/}
            {/*                                    message: 'Please select fund name'*/}
            {/*                                }]}>*/}
            {/*                                <Select placeholder={"Select fund name"}*/}
            {/*                                        getPopupContainer={(trigger: {*/}
            {/*                                            parentNode: any;*/}
            {/*                                        }) => trigger.parentNode}*/}
            {/*                                        style={{width: '100%'}}*/}
            {/*                                        options={fundDropdownList}*/}
            {/*                                />*/}
            {/*                            </Form.Item>*/}
            {/*                        </Col>*/}
            {/*                        <Col xxl={6} xl={12} lg={24} md={24} sm={24} xs={24}>*/}
            {/*                            <Form.Item*/}
            {/*                                label="Date"*/}
            {/*                                name={"yieldDate"}*/}
            {/*                                rules={[{*/}
            {/*                                    required: true,*/}
            {/*                                    message: 'Please select date'*/}
            {/*                                }]}>*/}
            {/*                                <DatePicker showToday={false}*/}
            {/*                                            disabledDate={(d: {*/}
            {/*                                                isBefore: (arg0: dayjs.Dayjs) => any*/}
            {/*                                            }) => !d || d.isBefore(dayjs())}*/}

            {/*                                            placeholder={'Select date'}*/}
            {/*                                            style={{width: '100%'}}/>*/}
            {/*                            </Form.Item>*/}
            {/*                        </Col>*/}
            {/*                        <Col xxl={6} xl={12} lg={24} md={24} sm={24} xs={24}>*/}
            {/*                            <Form.Item*/}
            {/*                                label={<><span className='custom-astrix'>*</span>Yield</>}*/}
            {/*                                name={'yield'}*/}
            {/*                                rules={[*/}
            {/*                                    {*/}
            {/*                                        validator: validatePercentage*/}
            {/*                                    },*/}
            {/*                                    {*/}
            {/*                                        pattern: DIGITS_AND_DOT_VALIDATION,*/}
            {/*                                        message: 'These special characters are not allowed'*/}
            {/*                                    }*/}
            {/*                                ]}>*/}
            {/*                                <Input onKeyPress={Validation.isNumber}*/}
            {/*                                       onBlur={handleYieldBlur}*/}
            {/*                                       autoComplete="off"*/}
            {/*                                       addonAfter="%"*/}
            {/*                                       placeholder={"Enter yield"}/>*/}
            {/*                            </Form.Item>*/}
            {/*                        </Col>*/}
            {/*                    </Row>*/}
            {/*                </Form>*/}
            {/*            </Card>*/}
            {/*        </Col>*/}
            {/*        <Col span={24}>*/}
            {/*            <Divider style={{marginBottom: 12}}></Divider>*/}
            {/*        </Col>*/}
            {/*        <Col span={24}>*/}
            {/*            <Space style={{float: 'right'}}>*/}
            {/*                <Button icon={<EditOutlined/>} type="success" onClick={updateCurrentYieldDetail}*/}
            {/*                        style={{*/}
            {/*                            width: 100,*/}
            {/*                            background: "#008d86",*/}
            {/*                            color: "white",*/}
            {/*                        }}>Save</Button>*/}
            {/*            </Space>*/}
            {/*        </Col>*/}
            {/*    </Row>*/}

            {/*</Modal>*/}
        </>


    )

}
export default FundDetails;

